import { Controller } from "@hotwired/stimulus"
import Cropper from 'cropperjs'
import 'cropperjs/dist/cropper.css'
import { post } from "@rails/request.js";

export default class extends Controller {
  static targets = ["input", "imgPreview"]
  static values = {
    url: String,
  };

  setupCropper(e) {
    let files;

    if (e.dataTransfer) {
      files = e.dataTransfer.files
    } else if (e.target) {
      files = e.target.files
    }
  
    const reader = new FileReader()
    reader.onload = () => {
      this.inputTarget.src = reader.result
      this.#initializeCropper();
    }

    reader.readAsDataURL(files[0])
  }

  async crop(){
    const imgBase64 = this.cropper.getCroppedCanvas().toDataURL();

    if (this.imgPreviewTarget.tagName === 'IMG') {
      this.imgPreviewTarget.src = imgBase64;
    } else {
      this.imgPreviewTarget.style.backgroundImage = `url(${imgBase64})`;
    }
    
    this.dispatch("crop");

    const res = await post(this.urlValue, { responseKind: "turbo-stream", body: {
      "course": {
        "image": imgBase64,
      }
    }});

    console.log(`Course image update status is: ${res.ok}`);
  }

  #initializeCropper() {
    if (this.cropper) {
      this.cropper.destroy();
    }
  
    this.cropper = new Cropper(this.inputTarget, {
      aspectRatio: 16 / 9,
      viewMode: 3
    })
  }
}
